import { ensureSquircleStyles } from '@/design-system'
import { Router } from '@solidjs/router'
import { render } from 'solid-js/web'
import { AppRoot, AppRoutes } from './App'
import './index.css'
import { initLangfuse } from './langfuse'
import { initPostHog } from './posthog'
import { isSensitiveLocation } from './posthog/publicRoute'
import { installChunkReloadRecovery } from './shared/utils/chunkReload'

if (!isSensitiveLocation(window.location.pathname, window.location.search)) {
  initPostHog()
}
initLangfuse()
installChunkReloadRecovery()

ensureSquircleStyles()

const root = document.getElementById('root')

if (!root) {
  throw new Error('Root element not found')
}

// Public pages arrive with a crawler snapshot inside #root; without this every page renders twice.
root.replaceChildren()

render(
  () => (
    <Router root={AppRoot}>
      <AppRoutes />
    </Router>
  ),
  root
)
